import { useState } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import UploadFileIcon from '@mui/icons-material/UploadFile'
import { useTranslation } from 'react-i18next'

// Lets the user upload a file straight from their device and attach it to a
// compliance requirement, instead of picking from the client's existing
// documents. Mirrors the "Upload new" option from the (now hidden) admin
// SocietyComplianceDocuments flow.
export default function UploadComplianceDocumentDialog({ open, onClose, onUpload }) {
  const { t } = useTranslation()
  const [file, setFile] = useState(null)
  const [uploading, setUploading] = useState(false)

  const handleClose = () => {
    setFile(null)
    onClose()
  }

  const handleUpload = async () => {
    if (!file) return
    setUploading(true)
    try {
      await onUpload(file)
      setFile(null)
    } finally {
      setUploading(false)
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth='sm' fullWidth>
      <DialogTitle>{t('attach_document')}</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
        <Button component='label' variant='outlined' startIcon={<UploadFileIcon />} sx={{ alignSelf: 'flex-start' }}>
          {t('Upload new')}
          <input
            key={file ? file.name : 'empty'}
            type='file'
            hidden
            accept='.pdf,.doc,.docx,.png,.jpg,.jpeg'
            onChange={(e) => setFile(e.target.files[0] || null)}
          />
        </Button>

        {file && (
          <Box
            sx={{
              p: 1,
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
          >
            <Typography variant='body2' sx={{ fontStyle: 'italic' }}>
              {t('Selected file')}: <strong>{file.name}</strong>
            </Typography>
            <Button size='small' color='error' onClick={() => setFile(null)}>
              {t('Discard')}
            </Button>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{t('Close')}</Button>
        <Button
          variant='contained'
          disabled={!file || uploading}
          onClick={handleUpload}
          sx={{
            backgroundColor: window.$brand === 'PRB' ? '#17afb6' : '#102a46',
            borderRadius: window.$brand === 'PRB' ? 0 : 5
          }}
        >
          {t('Save')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
